// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dd31006766--wrapper--2RiQf","icon":"dd31006766--icon--1WTpt","message":"dd31006766--message--2ubEc","link":"dd31006766--link--1IEqj"};